export default __webpack_public_path__ + "static/media/slide2.c4c8d1c0.jpg";